import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconLocationProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconLocationSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconLocationSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M8.94669 1.33337H7.05336C6.43089 1.33599 5.81503 1.4612 5.24095 1.70183C4.66687 1.94246 4.14581 2.29381 3.70751 2.73582C3.26922 3.17783 2.92228 3.70183 2.6865 4.27793C2.45072 4.85402 2.33072 5.47091 2.33336 6.09337C2.33336 9.25337 8.00002 14.6667 8.00002 14.6667C8.00002 14.6667 13.6667 9.25337 13.6667 6.09337C13.6693 5.47091 13.5493 4.85402 13.3135 4.27793C13.0778 3.70183 12.7308 3.17783 12.2925 2.73582C11.8542 2.29381 11.3332 1.94246 10.7591 1.70183C10.185 1.4612 9.56916 1.33599 8.94669 1.33337ZM8.00002 7.33337C7.73631 7.33337 7.47853 7.25518 7.25926 7.10867C7.04 6.96216 6.8691 6.75392 6.76818 6.51028C6.66727 6.26665 6.64086 5.99856 6.69231 5.73992C6.74376 5.48128 6.87074 5.2437 7.05721 5.05723C7.24368 4.87076 7.48126 4.74377 7.7399 4.69233C7.99854 4.64088 8.26663 4.66728 8.51027 4.7682C8.7539 4.86912 8.96214 5.04001 9.10865 5.25928C9.25516 5.47855 9.33336 5.73633 9.33336 6.00004C9.33336 6.35366 9.19288 6.6928 8.94283 6.94285C8.69278 7.1929 8.35364 7.33337 8.00002 7.33337Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconLocationSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M9.33336 6.00004C9.33336 6.26375 9.25516 6.52153 9.10865 6.7408C8.96214 6.96007 8.7539 7.13096 8.51027 7.23188C8.26663 7.3328 7.99854 7.3592 7.7399 7.30775C7.48126 7.25631 7.24368 7.12932 7.05721 6.94285C6.87074 6.75638 6.74376 6.5188 6.69231 6.26016C6.64086 6.00152 6.66727 5.73343 6.76818 5.4898C6.8691 5.24616 7.04 5.03792 7.25926 4.89141C7.47853 4.74491 7.73631 4.66671 8.00002 4.66671C8.35364 4.66671 8.69278 4.80718 8.94283 5.05723C9.19288 5.30728 9.33336 5.64642 9.33336 6.00004ZM8.94669 2.33337H7.05336C6.56221 2.33599 6.07639 2.43533 5.62363 2.6257C5.17088 2.81608 4.76005 3.09377 4.41462 3.44292C4.06918 3.79207 3.7959 4.20584 3.61038 4.66061C3.42485 5.11537 3.33072 5.60223 3.33336 6.09337C3.33336 7.87337 5.96002 11.1667 8.00002 13.26C10.04 11.1667 12.6667 7.87337 12.6667 6.09337C12.6693 5.60223 12.5752 5.11537 12.3897 4.66061C12.2041 4.20584 11.9309 3.79207 11.5854 3.44292C11.24 3.09377 10.8292 2.81608 10.3764 2.6257C9.92366 2.43533 9.43784 2.33599 8.94669 2.33337ZM8.94669 1.33337C9.56916 1.33599 10.185 1.4612 10.7591 1.70183C11.3332 1.94246 11.8542 2.29381 12.2925 2.73582C12.7308 3.17783 13.0778 3.70183 13.3135 4.27793C13.5493 4.85402 13.6693 5.47091 13.6667 6.09337C13.6667 9.25337 8.00002 14.6667 8.00002 14.6667C8.00002 14.6667 2.33336 9.25337 2.33336 6.09337C2.33072 5.47091 2.45072 4.85402 2.6865 4.27793C2.92228 3.70183 3.26922 3.17783 3.70751 2.73582C4.14581 2.29381 4.66687 1.94246 5.24095 1.70183C5.81503 1.4612 6.43089 1.33599 7.05336 1.33337H8.94669Z" />
    </svg>
  );
}

export default function IconLocation({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconLocationProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
